<app-confirm-dialog
  [visible]="true"
  [title]="
    status === 'success'
      ? 'Your email is verified successfully'
      : status === 'loading'
        ? 'Verifying your email…'
        : 'Verification failed'
  "
  [description]="description"
  [confirmButtonText]="confirmText"
  [showSecondaryButton]="false"
  [showButtons]="showButtons"
  [isConfirmLoading]="status === 'loading'"
  [confirmButtonVariant]="status === 'success' ? 'main' : 'secondary'"
  [iconSrc]="icon"
  (confirm)="onConfirm()"
  (cancel)="onConfirm()"
></app-confirm-dialog>
